import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { StorySection } from './components/StorySection';
import { ProblemSection } from './components/ProblemSection';
import { SituationsSection } from './components/SituationsSection';
import { VolumesSection } from './components/VolumesSection';
import { ExtraToolsSection } from './components/ExtraToolsSection';
import { BonusesSection } from './components/BonusesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { OutcomesSection } from './components/OutcomesSection';
import { CreatorSection } from './components/CreatorSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-canvas" data-id="element-0" data-mp="3ml1397n9rmih">
      <MetaPixel data-id="element-1" data-mp="3mj6j3vjtnyfg" />
      <main data-id="element-2" data-mp="3rcj8i7wbs999">
        <Hero data-id="element-3" data-mp="3rbzmog3k10py" />
        <StorySection data-id="element-4" data-mp="3rdatkosaqola" />
        <ProblemSection data-id="element-5" data-mp="3rd1a7k1rbfok" />
        <SituationsSection data-id="element-6" data-mp="5yk6vxnnffx" />
        <VolumesSection data-id="element-7" data-mp="67z9oh5w26u" />
        <ExtraToolsSection data-id="element-8" data-mp="4n725ibkvc5" />
        <BonusesSection data-id="element-9" data-mp="82j0zgp5o9c" />
        <TestimonialsSection data-id="element-10" data-mp="2zld2xbxu5jcl" />
        <OfferSection data-id="element-11" data-mp="2zm4xcjfp5b1a" />
        <GuaranteeSection data-id="element-12" data-mp="2zmwi0z7r9ocs" />
        <OutcomesSection data-id="element-13" data-mp="33mouhn09senf" />
        <CreatorSection data-id="element-14" data-mp="33m5eibu6k0c1" />
        <FaqSection data-id="element-15" data-mp="33nggq77z9011" />
        <FinalCtaSection data-id="element-16" data-mp="33myix65o2dr0" />
      </main>
      <Footer data-id="element-17" data-mp="38m1jadapbvsn" />
      <FloatingCta data-id="element-18" data-mp="38li7lebna3n2" />
      <PurchasePopup data-id="element-19" data-mp="38l06a3a4kz8a" />
    </div>;
}